// start and stop are included
export const range = (start, stop, step = 1) =>
  Array(Math.ceil((stop + 1 - start) / step)).fill(start).map((x, y) => x + y * step)

export const numberArrayGenerator = (max, withoutZero = true) => {
  return range(withoutZero ? 1 : 0, max)
}
